module.exports = require("./ta-SG");